import { render } from "./ManageAccount.vue?vue&type=template&id=40811c5e&lang=pug"
import script from "./ManageAccount.vue?vue&type=script&lang=js"
export * from "./ManageAccount.vue?vue&type=script&lang=js"

import "./ManageAccount.vue?vue&type=style&index=0&id=40811c5e&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__